import Content from '../../content';

namespace('IO.Views.HierarchyDefinitions', function (exports) {
  'use strict';

  var New = Content.extend({
    jstTemplate: 'hierarchy_definitions/level-item',

    dom: {
      CONTAINER: '.hierarchy-definitions-form .io-form-table',
      DELETE_BUTTON: '#answer-delete',
    },

    events: {
      'click .hierarchy-definitions-form .remove-button': '_showModal',
      'click .hierarchy-definitions-form .add-button': '_addItem',
    },

    _addItem: function (e) {
      var parent = $(e.target).parents('.level-definition-item'),
        parentLevel = parseInt(parent.attr('rel'), 10);

      if (parentLevel < HierarchyMaximumLevels) {
        $(this.dom.CONTAINER).append(
          this.renderTemplate({
            level: parentLevel + 1,
            maximum: HierarchyMaximumLevels,
          }),
        );
        $('.level-definition-item')
          .last()
          .find('input[type="text"]')
          .trigger('focus');
      }

      parent.removeClass('last');
      e.preventDefault();
    },

    _warnImpactedObjects: function (data, proceedCallback) {
      var warnModal = new IO.Views.Components.ConfirmationDialog({
        url:
          '/' +
          currentCustomer +
          '/hierarchy_definitions_impacted_objects?level=' +
          data,
        template: 'hierarchy_definitions/impacted_objects',
        method: 'GET',
        modalWidth: 800,
        modalHeight: '80%',
      });

      warnModal.impact(data);
      warnModal.answer(function (proceed) {
        if (proceed) {
          proceedCallback();
        }
        warnModal.destroy();
      });
    },

    _showModal: function (e) {
      var self = this,
        parent = $(e.target).parents('.level-definition-item'),
        parentLevel = parseInt(parent.attr('rel'), 10);

      this._warnImpactedObjects(parentLevel, function () {
        self._removeItem(parent);
      });
    },

    _removeItem: function (parent) {
      var parentLevel = parseInt(parent.attr('rel'), 10),
        previousLevel = $(this.dom.CONTAINER).find(
          '.level-definition-item[rel="' + (parentLevel - 1) + '"]',
        ),
        i,
        level;

      previousLevel.addClass('last');
      for (i = parentLevel; i <= HierarchyMaximumLevels; i++) {
        level = $(this.dom.CONTAINER).find(
          '.level-definition-item[rel="' + i + '"]',
        );
        level.remove();
      }
    },
  });

  exports.New = New;
});
